import { useEffect } from 'react';
import ImageBanner from './ImageBanner';
import ApplicationRequirementsSection from './ApplicationRequirementsSection';
import JourneyTimeline from './JourneyTimeline';
import AboutCathayHackathon from './AboutCathayHackathon';
import EventDetailsSection from './EventDetailsSection';
import HighlightsSection from './HighlightsSection';
import PrizesSection from './PrizesSection';
import FAQSection from './FAQSection';
import WinnerCardsSection from './WinnerCardsSection';
import SponsorSection from '../../layouts/SponsorSection';
import { updatePageview } from '../../../helpers/cxDataLayer';
import { useFeatureToggles } from '../../../contexts/FeatureTogglesContext';

function AboutPage() {
  const {
    winner_cards: winnerCardsEnabled,
    faq: faqEnabled,
    sponsors: sponsorsEnabled
  } = useFeatureToggles();
  const showWinnerCards = winnerCardsEnabled ?? true;
  const showFaq = faqEnabled ?? true;
  const showSponsors = sponsorsEnabled ?? true;
  const lang = window.location.pathname.slice(1,6);

  useEffect(() => {
    updatePageview({
      name: 'HACKATHON/HOMEPAGE',
      language: lang.split('_')[0],
      country: lang.split('_')[1],
      locale: lang
    });
  }, [lang]);

  return (
    <div id="about-session">
      <ImageBanner />
      <EventDetailsSection />
      {showWinnerCards ? <WinnerCardsSection /> : null}
      <HighlightsSection />
      <AboutCathayHackathon />
      <JourneyTimeline/>
      <PrizesSection />
      <ApplicationRequirementsSection />
      {showFaq ? <FAQSection /> : null}
      {showSponsors ? <SponsorSection /> : null}
    </div>
  );
}

export default AboutPage;
